import { createReducer } from '@reduxjs/toolkit';
import { GET_CUSTOMERS, SET_CUSTOMERS_LOADING } from '../actions/customers';

// TODO: infer type from docs
export type CustomerState = {
  customers: {
    rows: {
      id: string;
      name: string;
      tel: string;
      email: string;
      money_balance: number;
      point_balance: number;
      registered_at: string;
      last_transaction_done_at: string;
      external_id: string;
      account_status: string;
      account_uuid: string;
    }[];
    pagination: {
      current: number;
      per_page: number;
    };
    count: number;
    per_page: number;
    prev: string;
    next: string;
  };
  isLoading: boolean;
};

const initialState: CustomerState = {
  customers: {
    rows: [],
    pagination: {
      current: 1,
      per_page: 50,
    },
    count: 0,
    per_page: 0,
    prev: '',
    next: '',
  },
  isLoading: false,
};

const customersReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(GET_CUSTOMERS, (state, action) => {
      return { ...state, customers: action.payload, isLoading: false };
    })
    .addCase(SET_CUSTOMERS_LOADING, (state) => {
      return { ...state, isLoading: true };
    })
);

export default customersReducer;
